import React from 'react';
import { useTranslator } from 'tradera-lang/translate';

const SHIPPING_TYPES = {
    NotSpecified: 'NotSpecified',
    Takeaway: 'Takeaway',
    TakeawayOnly: 'TakeawayOnly'
};

const ShippingLabel = ({
    className,
    hasFreeShipping,
    shippingOptions,
    tagName: TagName
}) => {
    const { t } = useTranslator();

    if (hasFreeShipping) {
        return (
            <TagName
                className={`badge badge-tertiary badge-inline text-nowrap ${className ||
                    ''}`}>
                {t('itemCard_freeShipping')}
            </TagName>
        );
    }

    const hasNonSpecifiedShipping =
        !shippingOptions ||
        !shippingOptions.length ||
        (shippingOptions.length === 1 &&
            shippingOptions[0].type === SHIPPING_TYPES.NotSpecified);

    if (hasNonSpecifiedShipping) {
        return (
            <TagName className={`text-nowrap ${className || ''}`}>
                {t('itemCard_nonSpecifiedShipping')}
            </TagName>
        );
    }

    const isPickupOnly =
        shippingOptions.length === 1 &&
        [SHIPPING_TYPES.Takeaway, SHIPPING_TYPES.TakeawayOnly].includes(
            shippingOptions[0].type
        );

    if (isPickupOnly) {
        return (
            <TagName className={`text-nowrap ${className || ''}`}>
                {t('itemCard_pickup')}
            </TagName>
        );
    }

    const shippingCost = shippingOptions[0].cost;

    if (shippingCost) {
        return (
            <TagName className={`text-nowrap ${className || ''}`}>
                {t('itemCard_shippingCost', { shippingCost })}
            </TagName>
        );
    }

    return null;
};

ShippingLabel.defaultProps = {
    tagName: 'span'
};

export default ShippingLabel;
